import {SelectTwoLineIcon} from 'shells/select-two-line-icon/select-two-line-icon';
import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

import {useGetMeetingsForReport} from './graphql/hooks/use-get-meetings-for-report';

import styles from './scheduler-report.module.css';

interface Props {
    meetingId: string | null;
    handleMeetingChange: (meetingOption: TwoLineOptionWithIcon | null) => void;
}

export function MeetingSelector(props: Props) {
    const {loadOptions, selectedOption, isLoading} = useGetMeetingsForReport(props.meetingId);

    return (
        <div className={styles['selectors-container']}>
            <div className='half-width'>
                <SelectTwoLineIcon
                    loadOptions={loadOptions}
                    value={selectedOption}
                    onChange={props.handleMeetingChange}
                    onClear={() => props.handleMeetingChange(null)}
                    placeholder='Select a meeting'
                    isLoading={isLoading}
                    isSearchable={true}
                />
            </div>
        </div>
    );
}
